<app-static-pages-header [title]="title"></app-static-pages-header>
<div class="container anb">
  <div class="row justify-content-md-center">
    <div class="col-md-8">
      <h2 class="main__title">{{title}}</h2>
      <ol class="app__justify-text">
        <li>
          <h5>Veranstalter des Gewinnspiels</h5>
          <p>
            SFA Sport GmbH („fan.at“)<br>
            Geidorfplatz 1/10; 8010 Graz<br>
            E-Mail: info@fan.at
          </p>
        </li>
        <li>
          <h5>Teilnahmeberechtigung</h5>
          <p>
            Teilnahmeberechtigt sind Fußball-Vereine des OÖFV mit einer Kampfmannschaft in der Regionalliga oder darunter.
          </p>
        </li>
        <li>
          <h5>Einreichungen</h5>
          <p>per Plattform „fan.at“ bis 15.8.2021</p>
        </li>
        <li>
          <h5>Einlösefrist</h5>
          <p>bis 31.12.2022</p>
        </li>
        <li>
          <h5>Sonstige Wettbewerbsbedingungen</h5>
          <p>
            Fan.at behält sich das Recht vor, Teilnehmer auszuschließen, die die Verlosung unlauter
            (insbesondere durch Mehrfachteilnahmen) beeinflussen oder das versuchen. Der Gewinner
            wird nach Abschluss des Gewinnspiels ermittelt und per E-Mail, postalisch oder telefonisch
            benachrichtigt. Eine Barabgeltung des Gewinns und der Rechtsweg sind ausgeschlossen;
            beim Gewinner personenbezogen anfallende Steuern, Abgaben, Gebühren und Folgekosten trägt
            dieser selbst. Der Gewinner stimmt für den Fall des Gewinnes der Veröffentlichung seines
            Namens und allenfalls seines Lichtbildes zu.
          </p>
        </li>
        <li>
          <h5>Storno</h5>
          <p>
            Der Veranstalter behält sich das Recht vor, das Gewinnspiel jederzeit abzubrechen.
          </p>
        </li>
        <li>
          <h5>Haftung</h5>
          <p>
            Die Haftungen des Gewinnspielveranstalters und die seiner Erfüllungsgehilfen und
            Organe sind auf grobe Fahrlässigkeit und Vorsatz beschränkt.
          </p>
        </li>
      </ol>
    </div>
  </div>
</div>
